import React, {Component} from 'react';
import moment from 'moment';
import DatePicker from "react-datepicker";
import {applyOnEnum} from "src/utils/helpers";
import { getWorkflowDefinitionReasonCodes } from "src/actions/accountDetailsActions/accountDetails.actions";
// import { connect } from 'react-redux';
// import { showModal } from "src/actions/modal.actions";

class SummaryContainer extends Component {
    state = {
        isApplyOnVisible: false,
        applyOnType: '',
        provisionImmediately: false,
        provisionImmediatelyEnabled: true,
        reasoncodeId: null,
        // applyDate: this.props.accountInfo.billCycle? this.convertDay(this.props.accountInfo.billCycle): this.convertDay((new Date()).getDate()),
      startDate: this.props.accountInfo.billCycle? this.convertDay(this.props.accountInfo.billCycle): this.convertDay((new Date()).getDate()),
    }

  componentDidMount() {
    const { workFlowAttributes } = this.props;
    const attributesList = Array.isArray(workFlowAttributes) ? workFlowAttributes : [];

    if (attributesList.length > 0) {
      const attribute = attributesList[0];

      const allowedOptions = [
          attribute.allowOrderCompletion,
          attribute.allowStartOfBillCycle,
          attribute.allowNextBillCycle,
          attribute.allowSelectADate
      ].filter(Boolean).length;

      let defaultApplyOnType = Object.keys(applyOnEnum)[0];

      if (allowedOptions === 1) {
          if (attribute.allowOrderCompletion) {
              defaultApplyOnType = Object.keys(applyOnEnum)[0];
          } else if (attribute.allowStartOfBillCycle) {
              defaultApplyOnType = Object.keys(applyOnEnum)[1];
          } else if (attribute.allowNextBillCycle) {
              defaultApplyOnType = Object.keys(applyOnEnum)[2];
          } else if (attribute.allowSelectADate) {
              defaultApplyOnType = Object.keys(applyOnEnum)[3];
          }
      } else if (allowedOptions > 1) {
          if (attribute.orderCompletionDefault && attribute.allowOrderCompletion) {
              defaultApplyOnType = Object.keys(applyOnEnum)[0];
          } else if (attribute.startOfBillCycleDefault && attribute.allowStartOfBillCycle) {
              defaultApplyOnType = Object.keys(applyOnEnum)[1];
          } else if (attribute.nextBillCycleDefault && attribute.allowNextBillCycle) {
              defaultApplyOnType = Object.keys(applyOnEnum)[2];
          } else if (attribute.selectADateDefault && attribute.allowSelectADate) {
              defaultApplyOnType = Object.keys(applyOnEnum)[3];
          } else {
              if (attribute.allowOrderCompletion) {
                  defaultApplyOnType = Object.keys(applyOnEnum)[0];
              } else if (attribute.allowStartOfBillCycle) {
                  defaultApplyOnType = Object.keys(applyOnEnum)[1];
              } else if (attribute.allowNextBillCycle) {
                  defaultApplyOnType = Object.keys(applyOnEnum)[2];
              } else if (attribute.allowSelectADate) {
                  defaultApplyOnType = Object.keys(applyOnEnum)[3];
              }
          }
      }

      let provisionImmediately = false;
      let provisionImmediatelyEnabled = false;

      if (!attribute.allowProvisionImmediately) {
          provisionImmediately = false;
          provisionImmediatelyEnabled = false;
      } else {
          const isOrderCompletionOrBillCycle = (defaultApplyOnType === Object.keys(applyOnEnum)[0] || defaultApplyOnType === Object.keys(applyOnEnum)[1]);

          if (isOrderCompletionOrBillCycle) {
              provisionImmediately = true;
              provisionImmediatelyEnabled = false;
          } else {
              provisionImmediately = attribute.provisionImmediatelyDefault !== undefined ? attribute.provisionImmediatelyDefault : false;
              provisionImmediatelyEnabled = true;
          }
      }

      this.setState({
        applyOnType: defaultApplyOnType,
        provisionImmediately: provisionImmediately,
        provisionImmediatelyEnabled: provisionImmediatelyEnabled
      });
      if (this.props.setFieldValue) {
        this.props.setFieldValue('applyOn', defaultApplyOnType);
        this.props.setFieldValue('provisionImmediately', provisionImmediately);
      }
    } else {
      this.setState({
        applyOnType: Object.keys(applyOnEnum)[0],
        provisionImmediately: true,
        provisionImmediatelyEnabled: false
      });
      if (this.props.setFieldValue) {
        this.props.setFieldValue('applyOn', Object.keys(applyOnEnum)[0]);
        this.props.setFieldValue('provisionImmediately', true);
      }
    }
  }

    showHideCollapse = () => {
        this.setState((prevState) => ({
            isCollapsed: !prevState.isCollapsed
        }));
    };

    handleApplyOnDropdown = () => {
        this.setState((prevState) => ({
            isApplyOnVisible: !prevState.isApplyOnVisible
        }));
    }

	 convertDay(startDayBillCycle){
		let localdate = new Date();
		let currentMonth = localdate.getMonth();
		let currentYear = localdate.getFullYear();
		let currentDay = localdate.getDate();
		if( startDayBillCycle <= currentDay ) {
			return new Date(currentYear,currentMonth,startDayBillCycle);
		}else{
			return new Date(currentYear,currentMonth-1,startDayBillCycle);
		}
	}

  getFirstDayOfCurrentMonth() {
    const now = new Date();
    return new Date(now.getFullYear(), now.getMonth(), 1);
  }

  onApplyOnTypeChangeClickHandler = (e) => {
    const { workFlowAttributes } = this.props;
    const attributesList = workFlowAttributes || [];
    const attribute = attributesList.length > 0 ? attributesList[0] : { allowProvisionImmediately: true };

    const value = e.target.value;
    this.setState({applyOnType: value});

    if (!attribute.allowProvisionImmediately) {
      this.setState({
        provisionImmediately: false,
        provisionImmediatelyEnabled: false
      });
      this.props.setFieldValue('provisionImmediately', false);
    } else if (value && (value === Object.keys(applyOnEnum)[0] || value === Object.keys(applyOnEnum)[1])) {
      this.setState({
        provisionImmediately: true,
        provisionImmediatelyEnabled: false
      });
      this.props.setFieldValue('provisionImmediately', true);
    } else {
      this.setState({provisionImmediatelyEnabled: true});
      this.props.setFieldValue('provisionImmediately', this.state.provisionImmediately);
    }

    if (value) {
      this.props.values.applyOn = value;
      this.props.setFieldValue('applyOn', value);

      if (Object.keys(applyOnEnum)[3] === value) {
        const today = moment().format('YYYY-MM-DD');
        this.props.setFieldValue('applyDate', today);
        this.props.setApplyOnDate({
          applyOnPeriod: "APPLY_ON_DATE",
          applyOnDate: today
        });
        if (attribute.allowProvisionImmediately) {
          this.setState({
            provisionImmediatelyEnabled: true
          });
          this.props.setFieldValue('provisionImmediately', this.state.provisionImmediately);
        }
      } else {
        this.props.setApplyOnDate({
          applyOnPeriod: applyOnEnum.valueOf()[value].toLowerCase(),
          applyOnDate: ""
        });
      }
    }
  }

    onProvisionImmediatelyChangeHandler = (e) => {
        this.setState({provisionImmediately: e.target.checked});
        this.props.setFieldValue('provisionImmediately', e.target.checked);
    }

    handleChangeApplyOn = (e) => {
        const value = e.target.value;
		if (value) {
			this.props.values.applyOn = value;
            this.props.setFieldValue('applyOn', value);

            /**
             * If User doesn't manually select a date,
             * we remove apply on Date and set description for modal.
             * If they did select a date, we handle in handlChangeStartDateBillCycle
             */
            if(Object.keys(applyOnEnum)[3] === value) {
                const today = moment().format('YYYY-MM-DD');
                this.props.setFieldValue('applyDate', today);
                this.props.setApplyOnDate({
                  applyOnPeriod: "APPLY_ON_DATE",
                  applyOnDate: today
                });
            } else {
                this.props.setApplyOnDate({applyOnPeriod: applyOnEnum.valueOf()[value].toLowerCase(), applyOnDate:""})
            }
		}
	}

  openDatepicker = () => {
    this._calendar.setOpen(true);
    if(!this.props.values.applyOn) {
      this.props.setFieldValue('applyDate', moment().format('YYYY-MM-DD'));
    }
  }

  handlChangeStartDateBillCycle = (value) => {
    const { workFlowAttributes } = this.props;
    const attributesList = workFlowAttributes || [];
    const attribute = attributesList.length > 0 ? attributesList[0] : { allowProvisionImmediately: true };

    if (value instanceof Date) {
      value = moment(value).format('YYYY-MM-DD');
    }

    if(value) {
      this.props.setFieldValue('applyDate', value);
      this.props.setApplyOnDate({applyOnPeriod: "APPLY_ON_DATE", applyOnDate:value});

      const selectedDate = moment(value);
      const today = moment();

      if (!attribute.allowProvisionImmediately) {
        this.setState({
          provisionImmediately: false,
          provisionImmediatelyEnabled: false
        });
        this.props.setFieldValue('provisionImmediately', false);
      } else if (selectedDate.isSameOrBefore(today, 'day')) {
        this.setState({
          provisionImmediately: true,
          provisionImmediatelyEnabled: false
        });
        this.props.setFieldValue('provisionImmediately', true);
      } else {
        this.setState({
          provisionImmediatelyEnabled: true
        });
        this.props.setFieldValue('provisionImmediately', this.state.provisionImmediately);
      }
    }
  };

  onReasonCodeChangeHandler = (e) => {
    const value = e.target.value;
    const reasoncodeId = value ? parseInt(value, 10) : null;
    this.setState({ reasoncodeId });
    this.props.setFieldValue("reasoncodeId", reasoncodeId);
  }

  handleShowApplyOnModal = () => {
    const { showModal } = this.props;
    const { workFlowAttributes, reasonCodes } = this.props;
    let attributes = null;
    if (Array.isArray(workFlowAttributes) && workFlowAttributes.length > 0) {
        attributes = workFlowAttributes[0];
    } else {
        attributes = {
            allowOrderCompletion: true,
            allowStartOfBillCycle: false,
            allowNextBillCycle: false,
            allowSelectADate: false,
            allowProvisionImmediately: true,
            orderCompletionDefault: true,
            startOfBillCycleDefault: false,
            nextBillCycleDefault: false,
            selectADateDefault: false,
            provisionImmediatelyDefault: true
        };
    }
    const mockStatusTransition = {
        name: 'APPLY ON',
        fromStatus: 'Current',
        toStatus: 'Updated',
        workflowDefinitionAttributes: attributes,
        workflowDefinitionReasoncodes: reasonCodes.map(reason => ({
            reasoncode: {
                id: reason.id,
                description: reason.description
            }
        })),
        isLinesModal: true,
        isChangeFeature: true
    };

    showModal('ACCOUNT_STATUS_CHANGE_MODAL', {
        accountInfo: this.props.accountInfo,
        statusTransition: mockStatusTransition,
        onAccountStatusChange: this.handleApplyOnModalSubmit,
        onModalSubmit: this.handleModalValuesSubmit,
        currentValues: {
            applyOnType: this.state.applyOnType,
            applyOnDate: this.props.values && this.props.values.applyDate ? moment(this.props.values.applyDate).format('YYYY-MM-DD') : null,
            provisionImmediately: this.state.provisionImmediately,
            reasoncodeId: this.props.values ? this.props.values.reasoncodeId : null
        }
    });
  }

  handleModalValuesSubmit = (applyOnType, applyOnDate, provisionImmediately, reasoncodeId) => {
    if (this.props.setFieldValue) {
        this.props.setFieldValue('applyOn', applyOnType);
        const formattedDate = applyOnDate ? moment(applyOnDate).format('YYYY-MM-DD') : applyOnDate;
        this.props.setFieldValue('applyDate', formattedDate);
        this.props.setFieldValue('provisionImmediately', provisionImmediately);
        this.props.setFieldValue('reasoncodeId', reasoncodeId);
    }
    this.setState({
        applyOnType: applyOnType,
        provisionImmediately: provisionImmediately,
        reasoncodeId: reasoncodeId
    });
  }

  handleApplyOnModalSubmit = () => {

  }

    renderApplyOnUserFriendlyText = () => {
        if (this.state.applyOnType === Object.keys(applyOnEnum)[0]) {
            return "Order Completion"
        } else if (this.state.applyOnType === Object.keys(applyOnEnum)[1]) {
            return "Start of Bill Cycle"
        } else if (this.state.applyOnType === Object.keys(applyOnEnum)[2]) {
            return "Next Bill Cycle"
        } else if (this.state.applyOnType === Object.keys(applyOnEnum)[3]) {
            return "Select a Date"
        } else {
            return "ERROR"
        }
    }

    getApplyOnTypeLabel = () => {
        const { applyOnType } = this.state;
        if (applyOnType && applyOnEnum.valueOf()[applyOnType]) {
            return applyOnEnum.valueOf()[applyOnType].toUpperCase();
        }
        return "ORDER COMPLETION";
    }

    getApplyOnTypeDescription = () => {
        const { applyOnType } = this.state;
        switch(applyOnType) {
            case Object.keys(applyOnEnum)[0]:
                return "Order Completion";
            case Object.keys(applyOnEnum)[1]:
                return "Start of Bill Cycle";
            case Object.keys(applyOnEnum)[2]:
                return "Next Bill Cycle";
            case Object.keys(applyOnEnum)[3]:
                if (this.props.values && this.props.values.applyDate) {
                    return `Selected Date: ${moment(this.props.values.applyDate).format('MM/DD/YYYY')}`;
                }
                return "Select a Date";
            default:
                return "Order Completion";
        }
    }

    getSelectedReasonLabel = () => {
        const { reasonCodes } = this.props;

        if (!this.props.values || !this.props.values.reasoncodeId) {
            if (!reasonCodes || reasonCodes.length === 0) {
                return "NO REASON CODES LOADED";
            }
            return reasonCodes.length > 0 ? (reasonCodes[0].name || reasonCodes[0].description).toUpperCase() : "NO REASON SELECTED";
        }

        const selectedReason = reasonCodes.find(reason => reason.id === this.props.values.reasoncodeId);
        return selectedReason ? (selectedReason.name || selectedReason.description).toUpperCase() : "NO REASON SELECTED";
    }

    getSelectedReasonDescription = () => {
        const { reasonCodes } = this.props;

        if (!this.props.values || !this.props.values.reasoncodeId) {
            if (!reasonCodes || reasonCodes.length === 0) {
                return "No Reason Codes Loaded";
            }
            return reasonCodes.length > 0 ? reasonCodes[0].description : "";
        }

        const selectedReason = reasonCodes.find(reason => reason.id === this.props.values.reasoncodeId);
        return selectedReason ? selectedReason.description : "";
    }

  renderDynamicFields() {
    const { workFlowAttributes, values, startDate } = this.props;
    const { applyOnType, provisionImmediately } = this.state;
    const attributesList = workFlowAttributes || [];
    if (!attributesList.length) {
      return (
        <>
          <div className="form-check checkbox-slider checkbox-slider--b-flat">
            <label>
              <input
                type="radio"
                name="applyOnType"
                value={Object.keys(applyOnEnum)[0]}
                onChange={this.onApplyOnTypeChangeClickHandler}
                checked={applyOnType === Object.keys(applyOnEnum)[0]}
              />
              <span>
              Order Completion
              <p className="text-muted text-xs mb-0">
                Billing will take effect immediately, and provisioning will be triggered as soon as the request is submitted.
              </p>
            </span>
            </label>
          </div>

          <div className="form-check checkbox-slider checkbox-slider--b-flat">
            <label>
              <input
                type="radio"
                name="applyOnType"
                value={Object.keys(applyOnEnum)[1]}
                onChange={this.onApplyOnTypeChangeClickHandler}
                checked={applyOnType === Object.keys(applyOnEnum)[1]}
              />
              <span>
              Start of Bill Cycle
              <p className="text-muted text-xs mb-0">
                Billing will take effect as of the start of the current billing cycle, and provisioning will be triggered immediately.
              </p>
            </span>
            </label>
          </div>

          <div className="form-check checkbox-slider checkbox-slider--b-flat">
            <label>
              <input
                type="radio"
                name="applyOnType"
                value={Object.keys(applyOnEnum)[2]}
                onChange={this.onApplyOnTypeChangeClickHandler}
                checked={applyOnType === Object.keys(applyOnEnum)[2]}
              />
              <span>
              Next Bill Cycle
              <p className="text-muted text-xs mb-0">
                Billing will take effect at the start of the next billing cycle (1 second before midnight UTC). No proration will be applied.
              </p>
            </span>
            </label>
          </div>

          <div className="form-check checkbox-slider checkbox-slider--b-flat">
            <label>
              <input
                type="radio"
                name="applyOnType"
                value={Object.keys(applyOnEnum)[3]}
                onChange={this.onApplyOnTypeChangeClickHandler}
                checked={applyOnType === Object.keys(applyOnEnum)[3]}
              />
              <span>
              Select a Date
              <p className="text-muted text-xs mb-0">
                Billing will take effect on the selected date and time.
              </p>
            </span>
            </label>
          </div>

          {this.state.applyOnType === Object.keys(applyOnEnum)[3] &&
            <div className="input-group mr-2">
              <label>Date</label>
              <DatePicker
                className="form-control datetimepicker-input"
                selected={this.props.values.applyDate && moment(this.props.values.applyDate, 'YYYY-MM-DD').isValid() ? moment(this.props.values.applyDate, 'YYYY-MM-DD').toDate() : null}
                minDate={this.getFirstDayOfCurrentMonth()}
                onChange={(date) => {
                  this.handlChangeStartDateBillCycle(date);
                  this.openDatepicker()
                }}
                placeholderText="MM/DD/YYYY"
                name="expirationDate"
                popperPlacement="bottom-end"
                ref={(c) => this._calendar = c}
              />
            </div>
          }

          <div className="form-check checkbox-slider checkbox-slider--b-flat">
            <label>
              <input
                type="checkbox"
                name="provisionImmediately"
                disabled={!this.state.provisionImmediatelyEnabled}
                onChange={this.onProvisionImmediatelyChangeHandler}
                checked={provisionImmediately}
              />
              <span>
              Provision Immediately
              <p className="text-muted text-xs mb-0">
                Provisioning will be triggered immediately upon submitting the request.
              </p>
            </span>
            </label>
          </div>

        </>
      );
    }

    const attribute = attributesList[0];

    return (
      <>
        {attribute.allowOrderCompletion && (
          <div className="form-check checkbox-slider checkbox-slider--b-flat">
            <label>
              <input
                type="radio"
                name="applyOnType"
                value={Object.keys(applyOnEnum)[0]}
                onChange={this.onApplyOnTypeChangeClickHandler}
                checked={applyOnType === Object.keys(applyOnEnum)[0]}
              />
              <span>
              Order Completion
              <p className="text-muted text-xs mb-0">
                Billing will take effect immediately, and provisioning will be triggered as soon as the request is submitted.
              </p>
            </span>
            </label>
          </div>
        )}

        {attribute.allowStartOfBillCycle && (
          <div className="form-check checkbox-slider checkbox-slider--b-flat">
            <label>
              <input
                type="radio"
                name="applyOnType"
                value={Object.keys(applyOnEnum)[1]}
                onChange={this.onApplyOnTypeChangeClickHandler}
                checked={applyOnType === Object.keys(applyOnEnum)[1]}
              />
              <span>
              Start of Bill Cycle
              <p className="text-muted text-xs mb-0">
                Billing will take effect as of the start of the current billing cycle, and provisioning will be triggered immediately.
              </p>
            </span>
            </label>
          </div>
        )}

        {attribute.allowNextBillCycle && (
          <div className="form-check checkbox-slider checkbox-slider--b-flat">
            <label>
              <input
                type="radio"
                name="applyOnType"
                value={Object.keys(applyOnEnum)[2]}
                onChange={this.onApplyOnTypeChangeClickHandler}
                checked={applyOnType === Object.keys(applyOnEnum)[2]}
              />
              <span>
              Next Bill Cycle
              <p className="text-muted text-xs mb-0">
                Billing will take effect at the start of the next billing cycle (1 second before midnight UTC). No proration will be applied.
              </p>
            </span>
            </label>
          </div>
        )}

        {attribute.allowSelectADate && (
          <div className="form-check checkbox-slider checkbox-slider--b-flat">
            <label>
              <input
                type="radio"
                name="applyOnType"
                value={Object.keys(applyOnEnum)[3]}
                onChange={this.onApplyOnTypeChangeClickHandler}
                checked={applyOnType === Object.keys(applyOnEnum)[3]}
              />
              <span>
              Select a Date
              <p className="text-muted text-xs mb-0">
                Billing will take effect on the selected date and time.
              </p>
            </span>
            </label>
          </div>
        )}

        {this.state.applyOnType === Object.keys(applyOnEnum)[3] &&
          <div className="input-group mr-2">
            <label>Date</label>
            <DatePicker
              className="form-control datetimepicker-input"
              selected={this.props.values.applyDate && moment(this.props.values.applyDate, 'YYYY-MM-DD').isValid() ? moment(this.props.values.applyDate, 'YYYY-MM-DD').toDate() : null}
              minDate={this.getFirstDayOfCurrentMonth()}
              onChange={(date) => {
                this.handlChangeStartDateBillCycle(date);
                this.openDatepicker()
              }}
              placeholderText="MM/DD/YYYY"
              name="expirationDate"
              popperPlacement="bottom-end"
              ref={(c) => this._calendar = c}
            />
          </div>
        }

        {attribute.allowProvisionImmediately && (
          <div className="form-check checkbox-slider checkbox-slider--b-flat">
            <label>
              <input
                type="checkbox"
                name="provisionImmediately"
                disabled={!this.state.provisionImmediatelyEnabled}
                onChange={this.onProvisionImmediatelyChangeHandler}
                checked={provisionImmediately}
              />
              <span>
              Provision Immediately
              <p className="text-muted text-xs mb-0">
                Provisioning will be triggered immediately upon submitting the request.
              </p>
            </span>
            </label>
          </div>
        )}
      </>
    );
  }

  getDefaultDescription(applyOnKey) {
    switch(applyOnKey) {
      case Object.keys(applyOnEnum)[0]:
        return "Billing will take effect immediately, and provisioning will be triggered as soon as the request is submitted.";
      case Object.keys(applyOnEnum)[1]:
        return "Billing will take effect as of the start of the current billing cycle, and provisioning will be triggered immediately.";
      case Object.keys(applyOnEnum)[2]:
        return "Billing will take effect at the start of the next billing cycle (1 second before midnight UTC). No proration will be applied.";
      case Object.keys(applyOnEnum)[3]:
        return "Billing will take effect on the selected date and time.";
      default:
        return "";
    }
  }

    render() {

        const {
            isApplyOnVisible,
            startDate,
            isCollapsed,
            applyOnType,
        } = this.state;

        const {
            values,
            isSummaryFullWith,
            handleFullWithSummary,
            isSummaryCollapsed,
            handleSummaryCollapsed,
            plansDetails,
            tab,
          accountAllowedStatusTransitions,
          reasonCodes,
          workFlowAttributes
        } = this.props;


        return (
            <div
                className={
                    isSummaryFullWith === true ? (
                        'col-lg-3 col-xl-4 panel-summary col-full-width'
                    ) : (
                        'col-lg-3 col-xl-4 panel-summary'
                    )
                }
            >
                <div className="services-summary">

                    <div className="services-summary-header">
                        Summary
                        <span className="ml-auto">
							<a className="btn-summary btn-summary-toggle" onClick={handleFullWithSummary}>
								<i className="fas fa-arrows-alt-h"/>&nbsp;View
							</a>
                            &nbsp;
                            <a className="btn-summary btn-summary-collapse" onClick={handleSummaryCollapsed}>
								<i className="fas fa-angle-double-up"/>&nbsp;Collapse
							</a>
						</span>
                    </div>

					{(tab === 'Products' || tab === 'Services') &&
                    <div className="services-summary-applyon d-flex justify-content-center">
                        <div className="row">
                            <div className="col-12">
                                <div className="d-flex justify-content-center align-items-start ">
                                    <div className="mr-sm-4">
                                        <label className="text-muted small mb-1 d-block">Apply On</label>
                                        <div
                                          className="cursor-pointer"
                                          onClick={this.handleShowApplyOnModal}
                                          style={{ cursor: "pointer" }}
                                        >
                                            <span className="btn btn-sm btn-outline-secondary dropdown-toggle" style={{verticalAlign: 'middle'}}>{this.getApplyOnTypeLabel()}</span>
                                            {this.getApplyOnTypeDescription() && (
                                                <>
                                                    <div className="text-muted small mt-1" style={{fontSize: '12px'}}>
                                                        {this.getApplyOnTypeDescription()}
                                                    </div>
                                                    {(this.state.applyOnType === Object.keys(applyOnEnum)[0] || this.state.applyOnType === Object.keys(applyOnEnum)[1] || this.state.provisionImmediately) && (
                                                        <div className="text-muted small mt-1" style={{fontSize: '12px'}}>
                                                            Provision Immediately
                                                        </div>
                                                    )}
                                                </>
                                            )}
                                        </div>
                                    </div>
                                    <div>
                                        <label className="text-muted small mb-1 d-block">Reason</label>
                                        <div
                                          className="cursor-pointer"
                                          onClick={this.handleShowApplyOnModal}
                                          style={{ cursor: "pointer" }}
                                        >
                                            <span className="badge badge-primary text-white" style={{fontSize: '.875rem', padding: '0.25rem 0.5rem', lineHeight: '1.7', borderRadius: '0.2rem', verticalAlign: 'middle'}}>
                                                {this.getSelectedReasonLabel()}
                                            </span>
                                            {this.getSelectedReasonDescription() && (
                                                <div className="text-muted small mt-1" style={{fontSize: '12px'}}>
                                                    {this.getSelectedReasonDescription()}
                                                </div>
                                            )}
                                        </div>
                                                                                        </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

					}


                    <div className="services-summary-body">
                        <div className="plan-wrapper" data-plan-type="wireless">
                            <h4>{plansDetails.description}</h4>

                            <div className="serviceline-wrapper">
                                <h5 className="clearfix">
									<span className="badge badge-line-type">
										{plansDetails.planRelation}
									</span>
                                </h5>

                                <div className="plan-section" data-opt-pmnt-type="pmnt-recurring">
                                    <h5>Recurring</h5>
                                    {values.features
                                        .filter((x) => x.featureType !== 'ACTIVATION' && x.description)
                                        .map((feature, inx, arr) => (
                                            <div className="package-wrapper" key={inx}>
                                                <div
                                                    className={
                                                        isSummaryCollapsed === false ? (
                                                            'package-option just-added'
                                                        ) : (
                                                            'package-option d-none'
                                                        )
                                                    }
                                                >
													<span className="po-title">
													{feature.featurePackageDescription ? (

                                                        `${feature.featurePackageDescription.replace(/\s<br><(\w+)\b[^<>]*>[\s\S]*?<\/\1>/g, '')}: ${feature.description}`
                                                    ) : (
                                                        `${feature.description}`
                                                    )}
													</span>
                                                    <span className="po-price">
                                                        {feature.featureVariabledQuantity
                                                            ? feature.recurringMonthlyPrice &&
                                                                ("$" + (feature.featureVariabledQuantity * Number(feature.recurringMonthlyPrice)).toFixed(2).replace(/\d(?=(\d{3}) +\.)/g, '$&,') + "/mo")
                                                            : feature.recurringMonthlyPrice &&
                                                                ("$" + Number(feature.recurringMonthlyPrice).toFixed(2).replace(/\d(?=(\d{3}) +\.)/g, '$&,') + "/mo")
                                                        }
													</span>
                                                </div>
                                            </div>
                                        ))}

                                    <p className="services-price-subtotal">
                                        Subtotal:&nbsp;<span className="service-price">
											${values.features.reduce((acc, currentValue, index) => {
                                                if (currentValue.featureType !== 'ACTIVATION') {
                                                    if (currentValue.featureVariabledQuantity) {
                                                        if (currentValue.recurringMonthlyPrice) {
                                                            acc += currentValue.featureVariabledQuantity * currentValue.recurringMonthlyPrice;
                                                        }
                                                    }
                                                    else if (currentValue.recurringMonthlyPrice) {
                                                        acc += Number(currentValue.recurringMonthlyPrice);
                                                    }
                                                }
                                                return acc;
                                            }, 0).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}/mo
										</span>
                                    </p>
                                </div>

                                <div className="plan-section" data-opt-pmnt-type="pmnt-onetime">
                                    <h5>Onetime</h5>
                                    {values.features
                                        .filter((x) => x.featureType === 'ACTIVATION' && x.description)
                                        .map((feature, inx, arr) => (
                                            <div className="package-wrapper" key={inx}>
                                                <div
                                                    className={
                                                        isSummaryCollapsed === false ? (
                                                            'package-option just-added'
                                                        ) : (
                                                            'package-option d-none'
                                                        )
                                                    }
                                                >
													<span className="po-title">
														{feature.featurePackageNote &&
                                                        `${feature.featurePackageNote}:`}{' '}
                                                        {feature.description}
													</span>
                                                    <span className="po-price">
														${feature.oneTimePrice
                                                        .toFixed(2)
                                                        .replace(/\d(?=(\d{3})+\.)/g, '$&,')}
													</span>
                                                </div>
                                            </div>
                                        ))}

                                    <p className="services-price-subtotal">
                                        Subtotal:&nbsp;<span className="service-price">
											${values.features
                                        .reduce((acc, currentValue, index) => {
                                            if (currentValue.featureType === 'ACTIVATION' && currentValue.oneTimePrice) {
                                                acc += currentValue.oneTimePrice;
                                            }
                                            return acc;
                                        }, 0)
                                        .toFixed(2)
                                        .replace(/\d(?=(\d{3})+\.)/g, '$&,')}
										</span>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="services-summary-footer">
                        <p className="services-price-total">
                            Recurring:{' '}
                            <span className="service-price">
								${values.features.reduce((acc, currentValue, index) => {
                                    if (currentValue.featureType !== 'ACTIVATION') {
                                        if (currentValue.featureVariabledQuantity) {
                                            if (currentValue.recurringMonthlyPrice) {
                                                acc += currentValue.featureVariabledQuantity * currentValue.recurringMonthlyPrice;
                                            }
                                        }
                                        else if (currentValue.recurringMonthlyPrice) {
                                            acc += Number(currentValue.recurringMonthlyPrice);
                                        }
                                    }
                                    return acc;
                                }, 0).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}/mo
							</span>
                        </p>
                        <p className="services-price-total">
                            OneTime:{' '}
                            <span className="service-price">
								${values.features
                                .reduce((acc, currentValue, index) => {
                                    if (currentValue.featureType === 'ACTIVATION' && currentValue.oneTimePrice) {
                                        acc += currentValue.oneTimePrice;
                                    }

                                    return acc;
                                }, 0)
                                .toFixed(2)
                                .replace(/\d(?=(\d{3})+\.)/g, '$&,')}
							</span>
                        </p>
                    </div>
                </div>
            </div>
        );
    }
}

export default SummaryContainer;
